import EmailForm, {
  EmailFormData,
} from '@components/common/EmailForm/EmailForm'
import { selectCountry } from '@redux/globalSlice'
import { selectModalProps } from '@redux/modalSlice'
import { useAppSelector } from '@redux/store'

import { selectWishlist } from '@redux/wishlistSlice'
import React, { PropsWithChildren } from 'react'

interface Props {}
type NativeAttrs = Omit<React.HTMLAttributes<HTMLDivElement>, keyof Props>

export type WishListModalProps = Props & NativeAttrs

const WishListModal = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren<WishListModalProps>
>(({ className, children, ...props }, ref) => {
  // get modal props

  const country = useAppSelector(selectCountry)
  const wishlist = useAppSelector(selectWishlist)

  const modalProps = useAppSelector(selectModalProps)

  const {
    textAboveInput,
    newsletterCheckboxLabel,
    submitBtnText,
    submitSuccessFullMsg,
  } = modalProps

  const handleSendEmail = async (data: EmailFormData): Promise<void> => {
    const req = await fetch(
      'https://hook.eu1.make.com/e99ta4vwnjxe5ge4nrdjsl24lr8l58bj',
      {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          ...data,
          currency: country.code,
          wishlist: wishlist,
          wishlist_link: `${process.env.NEXT_PUBLIC_BASEURL}/wishlist?wishlist=${wishlist}`,
        }),
      },
    )

    return Promise.resolve()
  }

  return (
    <div className={className} ref={ref} {...props}>
      <EmailForm
        submitSuccessFullMsg={submitSuccessFullMsg}
        onSubmit={handleSendEmail}
        title={textAboveInput}
        {...props}
        checkboxes={[
          {
            required: false,
            value: 'NEWSLETTER',
            label: newsletterCheckboxLabel,
          },
        ]}
        source="WISHLIST"
        // TODO: From Umbraco (when its working.)
        labelTo={'Send to'}
        labelRecipientsName={"Recipient's Name"}
        placeholder={"Recipient's Email"}
        labelPersonalMessage={'Add a personal message'}
        labelFrom={'From:'}
        labelYourFullName={'Your Full Name'}
        labelFromEmail={'Your Email'}
        submitBtnText={submitBtnText}
      />
    </div>
  )
})

WishListModal.displayName = 'WishListModal'
export default WishListModal
